export default {
    settingStatementStrategy: {
      header: {
        channel: 'Channel',
        name: 'Strategy Name',
      },
      strategy: 'Add Strategy',

      table: {
        sale: 'Sales Channel',
        name: 'Strategy Name',
        type: 'Billing Type',
        field: 'Value Field',
        keywords: 'Matching Keyword',
        amount: 'Amount Value',
        orderNumber: 'Order No. Value',
        refundForm: 'Refund Order No. value',
      },

      addAndEdit: {
        editTitle: 'Edit platform billing strategy',
        addTitle: 'Add platform billing strategy',
        name: 'Strategy Name',
        namePlaceholder: 'Please enter strategy name',
        type: 'Billing Type',
        sale: 'Sales Revenue',
        return: 'Refund Expenditure',
        channel: 'Channel',
        channelPlaceholder: 'Please Select Channel',
        field: 'value Field',
        fieldText: 'Please select value field',
        keywords: 'Matching Keyword',
        keywordsPlaceholder: 'Please enter matching keywords',
        orderNumber: 'Order No. Value',
        orderNumberText: 'Please select Order No. value',
        amount: 'Amount Value',
        fixedField: 'Select Fixed Field',
        calculate: 'Calculate By Formula',
        fieldPlaceholder: 'Please Select Field',
        rulesType: 'Please select billing type',
        refundNoField: 'Please select refund Order No. value',
        amountType: 'Please select amount value',
        enabledFlag: 'Please Select Status',
        filterKeyword: 'Support multiple values separated by |',
        fieldTitle: 'Field',
        addField: 'Add Field',
        calculationRules: 'Calculation Rules'
      }
    },
};
